import React, { useState, useEffect, useContext } from "react";
import { S3_URL } from "../services/Constants";
import { Card, Container, Row, Col, Button } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { handleIsActive, validateAndSanitizeUrl } from "../util/common";
import { fetchUserById, updateUserRecord } from "../services/users-service";
import Alert from "react-bootstrap/Alert";
import UserContext from "../context/user-context";

const UserProfile = () => {
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({});
  const [validated, setValidated] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [isError, setIsError] = useState(false);
  const [userInfo, setUserInfo] = useState(null);

  const handleClose = () => setShow(false);
  const [user] = useContext(UserContext);

  const setField = (field, value) => {
    setForm({
      ...form,
      [field]: value,
    });
  };

  const getUser = async () => {
    let response = await fetchUserById(user?.userId); // hard-coded for now (will change once we implement the user login)
    if (response.ok) {
      let data = await response.json();
      if (data != null) {
        setUserInfo(data);
        setValidated(false);
      }
    } else {
      setIsError(true);
    }
  };

  const updateUser = async () => {
    let data = await updateUserRecord(form);
    if (data.userId != null) {
      setIsUpdated(true);
    } else {
      setIsError(true);
    }
  };

  const handleUpdate = async () => {
    setForm(userInfo);
    setShow(true);
    setIsUpdated(false);
    setIsError(false);
  };

  const handleSubmmit = (event) => {
    event.preventDefault();
    setValidated(true);
    if (event.currentTarget.checkValidity() === true) {
      updateUser();
      setShow(false);
    }
  };

  useEffect(() => {
    getUser();
  }, []);

  useEffect(() => {
    if (isUpdated) {
      getUser();
    }
  }, [isUpdated, getUser]);

  const renderBannerMessage = () => {
    if (isUpdated) {
      return "User information has been successfully updated!";
    } else if (isError) {
      return "Something went wrong, please try again";
    }
  };

  return (
    <>
      <Container fluid className="userProfileContainer">
        <Row className="tableTitle generalFont">
          {userInfo?.firstName &&
            userInfo?.lastName &&
            `${userInfo?.firstName} ${userInfo?.lastName}`}
        </Row>
        <Row
          className="tableSubtitle generalFont"
          style={{ width: "95%", paddingRight: "30px" }}
        >
          <Col style={{ paddingLeft: "0px" }}></Col>
          <Col xl={4} className="editProfileButton">
            <Button
              className="editProfileBtn flexCenter generalFont"
              onClick={handleUpdate}
            >
              <img
                src={`${validateAndSanitizeUrl(S3_URL)}edit_profile_icon.png`}
                alt=""
                style={{ marginRight: "10px" }}
              ></img>
              Edit Profile
            </Button>
          </Col>
        </Row>
        {(isUpdated || isError) && (
          <Row
            style={{
              paddingRight: "40px",
              width: "95%",
            }}
          >
            <Alert
              key={"success"}
              variant={isError ? "danger" : "success"}
              onClose={() => {
                setIsUpdated(false);
                setIsError(false);
              }}
              dismissible
            >
              {renderBannerMessage()}
            </Alert>
          </Row>
        )}
        <Row
          style={{
            marginRight: "54px",
            marginTop: isUpdated || isError ? "0px" : "60px",
          }}
        >
          <Card className="userProfileCard">
            <Row
              className="modalHeader generalFont"
              style={{ padding: "40px 40px 0 40px" }}
            >
              <div className="cardBody" style={{ marginBottom: "40px" }}>
                <img
                  src={`${validateAndSanitizeUrl(S3_URL)}details-icon.png`}
                  style={{
                    width: "27px",
                    height: "27px",
                    marginRight: "10px",
                  }}
                  alt=""
                ></img>
                Basic Details
              </div>
              <Col sm={4}>
                <div className="repLoincModalTitle">First Name:</div>
                <div className="repLoincModalSubtitle">{userInfo?.firstName}</div>
              </Col>
              <Col sm={4}>
                <div className="repLoincModalTitle">Last Name:</div>
                <div className="repLoincModalSubtitle">{userInfo?.lastName}</div>
              </Col>
              <Col sm={4}>
                <div className="repLoincModalTitle">Username:</div>
                <div className="repLoincModalSubtitle">{userInfo?.userName}</div>
              </Col>
            </Row>
            <Row style={{ padding: "40px 40px 40px 40px" }}>
              <Col sm={4}>
                <div className="repLoincModalTitle">Role:</div>
                <div className="repLoincModalSubtitle">
                  {userInfo?.roles[0].roleName}
                </div>
              </Col>
              <Col sm={4}>
                <div className="repLoincModalTitle">Status:</div>
                <div className="repLoincModalSubtitle">
                  {handleIsActive(userInfo?.isActive)}
                </div>
              </Col>
            </Row>
            <hr style={{ margin: "30px" }}></hr>
            <Row
              className="modalHeader generalFont"
              style={{ padding: "40px 40px 0 40px" }}
            >
              <div className="cardBody" style={{ marginBottom: "40px" }}>
                <img
                  src={`${validateAndSanitizeUrl(S3_URL)}phone_icon.png`}
                  style={{
                    width: "27px",
                    height: "27px",
                    marginRight: "10px",
                  }}
                  alt=""
                ></img>
                Contact Details
              </div>
              <Col sm={4}>
                <div className="repLoincModalTitle">Phone Number:</div>
                <div className="repLoincModalSubtitle">{userInfo?.phoneNumber}</div>
              </Col>
              <Col sm={4}>
                <div className="repLoincModalTitle">Email:</div>
                <div className="repLoincModalSubtitle">{userInfo?.email}</div>
              </Col>
            </Row>
          </Card>
        </Row>
      </Container>

      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Form onSubmit={handleSubmmit} noValidate validated={validated}>
          <Modal.Header className="modalHeaderContainer" closeButton>
            <Modal.Title className="modalHeader generalFont">
              Edit Profile
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="modalBodyContainer">
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="form.firstName">
                  <React.Fragment>
                    <Form.Label className="modalLabel generalFont">
                      First Name <i className="text-danger">(required)</i>
                    </Form.Label>
                  </React.Fragment>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    placeholder="Hint Text"
                    required
                    value={form.firstName}
                    onChange={(e) => setField("firstName", e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="form.lastName">
                  <React.Fragment>
                    <Form.Label className="modalLabel generalFont">
                      Last Name <i className="text-danger">(required)</i>
                    </Form.Label>
                  </React.Fragment>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    placeholder="Hint Text"
                    required
                    value={form.lastName}
                    onChange={(e) => setField("lastName", e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="form.userName">
                  <React.Fragment>
                    <Form.Label className="modalLabel generalFont">
                      Username
                    </Form.Label>
                  </React.Fragment>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value={form.userName}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row style={{ marginTop: "20px" }}>
              <Col sm={4}>
                <Form.Group className="mb-3" controlId="form.role">
                  <React.Fragment>
                    <Form.Label className="modalLabel generalFont">
                      Role
                    </Form.Label>
                  </React.Fragment>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    value={form?.roles?.[0].roleName}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col sm={4}>
                <Form.Group className="mb-3" controlId="form.status">
                  <React.Fragment>
                    <Form.Label className="modalLabel generalFont">
                      Status
                    </Form.Label>
                  </React.Fragment>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    value={handleIsActive(form.isActive)}
                    disabled
                  />
                </Form.Group>
              </Col>
            </Row>
            <hr></hr>
            <Row style={{ marginTop: "40px" }}>
              <Col>
                <Form.Group className="mb-3" controlId="form.phoneNumber">
                  <React.Fragment>
                    <Form.Label className="modalLabel generalFont">
                      Phone Number
                    </Form.Label>
                  </React.Fragment>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    placeholder="Hint Text"
                    value={form.phoneNumber}
                    onChange={(e) => setField("phoneNumber", e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="form.email">
                  <React.Fragment>
                    <Form.Label className="modalLabel generalFont">
                      Email
                    </Form.Label>
                  </React.Fragment>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    placeholder="Hint Text"
                    value={form.email}
                    onChange={(e) => setField("email", e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer className="modalFooterContainer">
            <Button
              type="submit"
              className="modalAddUpdateStyle generalFont flexCenter"
            >
              <img
                src={`${validateAndSanitizeUrl(S3_URL)}plus-icon.png`}
                alt=""
                style={{ marginRight: "10px" }}
              ></img>
              Update
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default UserProfile;